var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"register-login"},[_c('div',{staticClass:"container"},[_c('Header',{attrs:{"title":"¿Olvidaste tu clave?","text":"No te preocupes, puedes recuperarla ingresando tu correo."}}),_c('FormRecoveryPassword')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }